<template>
  <div>
    
    <div class="bar_nav">
      <div class="title">添加成员</div>
      <div class="bar_back_btn" @click="goToGroupSetting">群组成员</div>
    </div>
    <div class="bar_empty"></div>

    <mt-search class="bar_search" v-model="mobilePhone" :result="userList" show>
      <div class="user_list_item" v-for="user in userList" :key="user.id" :title="user.fullName" :value="user.id">
        <div class="user_avatar">
          <img :src="user.avatarCdnUrl" alt="" v-if="user.avatar">
          <img src="../assets/avatar.png" alt="" v-if="!user.avatar">
          <div class="circle_border"></div>
        </div>
        <div class="user_name">{{user.fullName}}</div>
        <div class="btn btn_add" @click="addMemberToGroup(user.id)">加入群</div>
      </div>

      <div class="user_list_item" v-if="!userList.length && mobilePhone.length===11">
        <div class="user_avatar">       
          <img src="../assets/avatar.png" alt="">
          <div class="circle_border"></div>
        </div>
        <div class="user_name">{{mobilePhone}} (未注册)</div>
        <div class="btn btn_add" @click="noUseraddMemberToGroup(mobilePhone)">预先加入群</div>
      </div>
    </mt-search>

  </div>
</template>

<script>
export default {
  name: 'AddMember',
  data: function () {
    return {
      userList: [],
      mobilePhone: '',
      isSearching: false
    }
  },
  watch: {
    async mobilePhone() {
      try {
        this.userList = (await this.$faApi.searchUser(this.mobilePhone)).data
      } catch (err) {
        this.$faLogger.error('AddMember.vue:searchUser', err)
      }
    }
  },
  created() {
  },
  methods: {
    async noUseraddMemberToGroup(mobilePhone) {
      try {
        await this.$faApi.noUseraddUserToGroup(mobilePhone, this.$route.params.groupId)
        this.$router.push({ path: `/group/${this.$route.params.groupId}/setting` })
      } catch (err) {
        this.$faLogger.error('AddMember.vue:addMemberToGroup', err)
      }
    },
    async addMemberToGroup(userId) {
      try {
        await this.$faApi.addUserToGroup(this.$route.params.groupId, userId)
        this.$router.push({ path: `/group/${this.$route.params.groupId}/setting` })
      } catch (err) {
        this.$faLogger.error('AddMember.vue:addMemberToGroup', err)
      }
    },
    async goToGroupSetting() {
      this.$router.push({ path: `/group/${this.$route.params.groupId}/setting` })
    }
  }
}
</script>

<style scoped lang="scss">
  .bar_search {
    position: relative;
    color: gold !important;
  }
</style>
  